import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme, Box } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import CreateRaceCard from './pages/CreateRaceCard';
import RaceCards from './pages/RaceCards';
import Login from './pages/Login';
import Register from './pages/Register';
import { AuthProvider } from './context/AuthContext';
import MyAccount from './pages/MyAccount';
import Footer from './components/Footer';
import Help from './pages/Help';
import Privacy from './pages/Privacy';
import { cleanupExpiredRaceCardApplications } from './services/raceCardService';

const APPLICATION_CLEANUP_STORAGE_KEY = 'raceCardApplicationCleanupLastRun';
const CLEANUP_INTERVAL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days (once per month)

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 950,
      lg: 1200,
      xl: 1536,
    },
  },
});

function App() {
  // Run expired race card application cleanup at most once per month (in background)
  useEffect(() => {
    const lastRun = localStorage.getItem(APPLICATION_CLEANUP_STORAGE_KEY);
    const now = Date.now();
    if (!lastRun || now - parseInt(lastRun, 10) > CLEANUP_INTERVAL_MS) {
      cleanupExpiredRaceCardApplications()
        .then(() => {
          localStorage.setItem(APPLICATION_CLEANUP_STORAGE_KEY, String(now));
        })
        .catch((err) => {
          console.error('Expired application cleanup failed:', err);
        });
    }
  }, []);

  // In development, expose cleanup so you can run it manually and verify (e.g. in console: __runRaceCardApplicationCleanup().then(n => console.log('Deleted:', n)))
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      window.__runRaceCardApplicationCleanup = cleanupExpiredRaceCardApplications;
    }
  }, []);

  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Navbar />
            <Box sx={{ flex: 1 }}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/create-card" element={<CreateRaceCard />} />
                <Route path="/race-cards" element={<RaceCards />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/my-account" element={<MyAccount />} />
                <Route path="/help" element={<Help />} />
                <Route path="/privacy" element={<Privacy />} />
              </Routes>
            </Box>
            <Footer />
          </Box>
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
